// extracted by mini-css-extract-plugin
export default {"list":"pill-list_list__S0Xym","item":"pill-list_item__ZuEBH"};